import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { DataService } from './data.service';

@Injectable({
  providedIn: 'root'
})
export class DashboardService {

  constructor(private _data: DataService) { }

  DashboardCount(dashboardFilter: any): Observable<any> {
    return this._data.post(`Dashboard/DashboardCount`, dashboardFilter)
      .pipe(map(response => {
        return response;
      }));
  }
}
